import script from "./MiniStatisticsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MiniStatisticsCard.vue?vue&type=script&setup=true&lang=js"

import "./MiniStatisticsCard.vue?vue&type=style&index=0&id=6dfed126&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dfed126"]])

export default __exports__